import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ZoneComponent = ({ fulfillmentPlanId }) => {
  const zone = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'zone',
    }),
  );

  if (!zone) {
    return '';
  }

  return zone;
};

export const Zone = {
  getMessageDescriptor: () => messages.zone,
  id: 'zone',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }
    return <ZoneComponent fulfillmentPlanId={data.id} />;
  },
};
